import styled from 'styled-components';

export const DriverRatingViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
`;

export const DriverInfo = styled.div`
  display: flex;
  margin-bottom: 24px;
  align-items: flex-end;

  img {
    margin-left: 15px;
    max-width: 30px;
  }
`;

export const RatingTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
  margin-bottom: 24px;
  max-width: 100%;
`;

export const RatingTag = styled.div`
  padding: 8px 16px;
  border-radius: 20px;
  border: 2px solid #ff2d38;
  background: #fff5f5;
  color: #ff2d38;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`;

export const RatingDetails = styled.div`
  display: block;
  border: 2px solid #ff2d38;
  border-radius: 4px;
  background-color: #fff5f5;
  color: #ff2d38;
  width: 100%;
  padding: 8px 16px;
  word-break: break-word;
`;

export const SubmittedDate = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #666;
  margin-top: 24px;
`;
